import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { InfoTableConfig } from '../shared.interface';

@Component({
  selector: 'app-info-property-table',
  templateUrl: './info-property-table.component.html',
  styleUrls: ['./info-property-table.component.scss']
})
export class InfoPropertyTableComponent implements OnInit {
  @Input() tableData: InfoTableConfig;

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };

  constructor() {}

  ngOnInit(): void {}
}
